/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiplomeCertificationIfapmeFichierDto
 */
export interface DiplomeCertificationIfapmeFichierDto {
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierDto
     */
    iddiplomeCertificationIfapmeFichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierDto
     */
    iddiplomeCertificationIfapme?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierDto
     */
    idfichier?: number;
    /**
     * 
     * @type {number}
     * @memberof DiplomeCertificationIfapmeFichierDto
     */
    idtypeAcquisFichier?: number;
    /**
     * 
     * @type {string}
     * @memberof DiplomeCertificationIfapmeFichierDto
     */
    fileName?: string | null;
}

/**
 * Check if a given object implements the DiplomeCertificationIfapmeFichierDto interface.
 */
export function instanceOfDiplomeCertificationIfapmeFichierDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DiplomeCertificationIfapmeFichierDtoFromJSON(json: any): DiplomeCertificationIfapmeFichierDto {
    return DiplomeCertificationIfapmeFichierDtoFromJSONTyped(json, false);
}

export function DiplomeCertificationIfapmeFichierDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiplomeCertificationIfapmeFichierDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iddiplomeCertificationIfapmeFichier': !exists(json, 'iddiplomeCertificationIfapmeFichier') ? undefined : json['iddiplomeCertificationIfapmeFichier'],
        'iddiplomeCertificationIfapme': !exists(json, 'iddiplomeCertificationIfapme') ? undefined : json['iddiplomeCertificationIfapme'],
        'idfichier': !exists(json, 'idfichier') ? undefined : json['idfichier'],
        'idtypeAcquisFichier': !exists(json, 'idtypeAcquisFichier') ? undefined : json['idtypeAcquisFichier'],
        'fileName': !exists(json, 'fileName') ? undefined : json['fileName'],
    };
}

export function DiplomeCertificationIfapmeFichierDtoToJSON(value?: DiplomeCertificationIfapmeFichierDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iddiplomeCertificationIfapmeFichier': value.iddiplomeCertificationIfapmeFichier,
        'iddiplomeCertificationIfapme': value.iddiplomeCertificationIfapme,
        'idfichier': value.idfichier,
        'idtypeAcquisFichier': value.idtypeAcquisFichier,
        'fileName': value.fileName,
    };
}

